var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"classes":_vm.classes,"width":"400","height":"400","name":'modal-' + _vm.assignedName,"click-to-close":!_vm.strictClose},on:{"closed":function($event){return _vm.handleModalClose()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }